import { render } from "./project-view-modal.vue?vue&type=template&id=99664ba6"
import script from "./project-view-modal.vue?vue&type=script&lang=js"
export * from "./project-view-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__